/*
 * @Author: Lin Yunhe
 * @Date: 2023-03-23 11:05:50
 * @LastEditors: Lin Yunhe
 * @LastEditTime: 2023-03-24 17:22:18
 */
import React from 'react';
import { Helmet } from 'react-helmet';

interface CustomizedHeadProps {
    websiteInfo?: Record<string, any>;
}

/**
 * @name 自定义头部信息
 */
const CustomizedHead: React.FC<CustomizedHeadProps> = ({ websiteInfo }) => {
    return (
        <Helmet>
            <link rel="shortcut icon" type="images/x-icon" href={websiteInfo?.favicon} />
        </Helmet>
    );
};

export default CustomizedHead;
